import { render, staticRenderFns } from "./LevyCalculationPanelShortRegistration.vue?vue&type=template&id=31a076a9&"
import script from "./LevyCalculationPanelShortRegistration.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelShortRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports